import LoyaltyRedeemCashFormSFC from "./LoyaltyRedeemCashForm.vue";
export const LoyaltyRedeemCashForm = LoyaltyRedeemCashFormSFC;
